import { Modal, ModalHeader, ModalBody, InputGroup, Input, Button, Tooltip, FormText } from "reactstrap";
import { PutAuth } from "../utils/Verbs";
import { useEffect, useState } from "react";
import styles from './CollectionDeviceInstructions.css';
import { useVsiAppContext } from "../stores/VsiApp";
import { VsiH6, VsiSpanText } from "../styled/App.styled";
import themeStyles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

const CollectionDeviceInstructions = ({ showModal, toggle}) => {
    const { theme, client, user, getAccessTokenSilently }= useVsiAppContext();

    const [clientToken, setClientToken] = useState('');
    const [isVisible, setVisible] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const onTokenGenerateClick = async () => {
        try {
            const token = await getAccessTokenSilently();
            const response = await PutAuth('/api/v6/admin/clients/replace-vsi-client-token', { clientId: client.clientId }, token);
            const newClientToken = response?.data?.updatedToken;
            if (newClientToken) {
                setClientToken(newClientToken);
            }
        } catch (e) {
            console.error(e);
        }
    }

    const setDefaultState = () => {
        setClientToken('');
        setVisible(false);
        setTooltipOpen(false);
    }

    useEffect(() => {
        if (!showModal) {
            setDefaultState();
        }
    }, [showModal]);

        useEffect(() => {
            return () => {
                setDefaultState();
            }
        }, [showModal]);

    return (
        <Modal isOpen={showModal} size="lg">
            <ModalHeader toggle={toggle} className={`bg-${theme}`}>
                <VsiSpanText>VSI Collection Device Installation Instructions</VsiSpanText>
            </ModalHeader>
            <ModalBody className={`bg-${theme}`}>
                <VsiH6 className={styles.subTitle}>Make sure complete these steps before adding a collection device.</VsiH6>
                <ol className={styles.instructions} style={{ color: themeStyles[theme].textColor }}>
                    <li>Install <a href="https://www.python.org/downloads/" target="_blank" rel="noreferrer">Python</a></li>
                    <li>
                        <p>Install the VSI client</p>
                        <p>Use your terminal/bash window to run the following command</p>
                        <div>
                            <code>pip install -i https://packages.visual1intelligence.com/simple/ -U --trusted-host packages.visual1intelligence.com vsiclient</code>
                        </div>
                    </li>
                    <li>
                        Execute VSI Client
                        <div>
                            <code>vsiclient</code>
                        </div>
                    </li>
                    <li>
                        Generate VSI Client token and use Ctrl-C or Cmd-C to copy it to your clipboard
                        <div>
                            <code>
                                {clientToken ? (

                                <InputGroup>
                                      <Input 
                                            id="vsiClientTokenInput"
                                            type={isVisible ? 'text' : 'password'}
                                            value={clientToken}
                                            onChange={() =>{}}
                                        />
                                            <Button onClick={() => setVisible(!isVisible)}>
                                                <i className={`fa-solid fa-eye${isVisible ? '-slash' : ''}`}/>
                                            </Button>
                                       <FormText style={{width : "100%"}}>
                                         This token is not stored on our side and will be unrecoverable if this pop up is closed.
                                        </FormText>
                                </InputGroup>
                                ) : (
                                   <Button onClick={onTokenGenerateClick}>
                                        Generate
                                    </Button>
                                )}
                            </code>
                        </div>
                    </li>
                </ol>
            </ModalBody>
        </Modal>
    )
}

export default withErrorBoundary(CollectionDeviceInstructions, GeneralErrorBoundary);
